import React from "react";
import FormGroupMui, { FormGroupProps } from "@mui/material/FormGroup";

export type Props = FormGroupProps;

export function FormGroup({ children, ...props }: Props) {
  return <FormGroupMui {...props}>{children}</FormGroupMui>;
}
